import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isCheckbox", "sx", "isMenu", "isFirstElement", "isHeader"];
import * as React from 'react';

// TODO danielmana import from @lumahealthhq/ui-core

import { TableCell } from '@lumahealthhq/ui-core';
import getDefaultStylesAndProps from '../../../ContainerTableColumn/getDefaultStylesAndProps';
import { getStyles } from './getStyles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function TableCellCustomWrapped(_ref) {
  let {
      children,
      isCheckbox,
      sx,
      isMenu,
      isFirstElement,
      isHeader
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const columnStyle = getStyles(!!isCheckbox, !!isMenu, !!isFirstElement);
  const headerStyle = getDefaultStylesAndProps(!!isCheckbox, !!isMenu, !!isFirstElement);
  const style = isHeader ? headerStyle.styles : columnStyle;
  const allProps = isHeader ? _extends({}, headerStyle.props, props) : props;
  const onClick = React.useCallback(e => {
    if (isCheckbox || isMenu) {
      var _props$onClick;
      e.stopPropagation();
      props == null ? void 0 : (_props$onClick = props.onClick) == null ? void 0 : _props$onClick.call(props, e);
    }
  }, [isCheckbox, isMenu, props]);
  const isSxFn = typeof sx === 'function';
  return /*#__PURE__*/_jsx(TableCell, _extends({
    sx: theme => _extends({}, style(theme), isSxFn ? sx(theme) : sx),
    align: 'left',
    onClick: onClick
  }, allProps, {
    children: children
  }));
}
const TableCellCustom = /*#__PURE__*/React.memo(TableCellCustomWrapped);
export default TableCellCustom;